import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { ExamSessionDetails } from '../../../../../../../api/types/programs/course/course-details.type';

export const getExamDetailsOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number,
  setSessionDetails: (sessions: ExamSessionDetails[]) => any,
) => {
  try {
    if (!programId || !courseId) {
      toast.warn('ךא ניתר לאתר מזהה הקורס, נסה שוב בעוד מספר רגעים...');
      return;
    }
    const res = await appApi.getExamDetails(programId, courseId, examId);
    setSessionDetails(res.data.body);
  } catch (e) {
    toast.error('הפעולה נכשלה, נסה שוב בעוד מספר רגעים');
  }
};
